import { CATEGORY_COLOR_VARIANTS } from './CategoryCell.constants';

export const getCategoryColorVariant = name => {
  const hash = [...(name ?? '')].reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return CATEGORY_COLOR_VARIANTS[hash % CATEGORY_COLOR_VARIANTS.length];
};
